import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export const Objections = () => {
  const faqs = [{
    q: 'No soy una persona creativa, ¿puedo hacerlo?',
    a: "¡Totalmente! El método está diseñado con un paso a paso exacto. No necesitás 'inspiración', solo seguir las instrucciones y usar las plantillas que te damos."
  }, {
    q: 'No sé vender ni me gusta insistirle a la gente.',
    a: "Por eso te enseñamos a vender por Instagram de forma 'magnética'. La idea es que tu contenido atraiga a las personas, sin que tengas que perseguir a nadie."
  }, {
    q: 'No tengo experiencia previa haciendo velas.',
    a: 'El 90% de nuestras alumnas empezaron desde cero absoluto. Te enseñamos desde cómo derretir la cera hasta cómo empacarla.'
  }, {
    q: 'Ya compré cursos antes y no los terminé.',
    a: 'Este programa es diferente porque es 100% práctico. Cada módulo termina con una acción concreta para que veas resultados rápidos y te mantengas motivada.'
  }, {
    q: 'No tengo mucho tiempo libre.',
    a: 'Podés ver las clases a tu ritmo y empezar dedicándole solo 1 o 2 horas los fines de semana. Vos marcás tu propio ritmo.'
  }];
  return <section className="py-24 bg-nude/30" data-id="element-133">
      <div className="max-w-3xl mx-auto px-6" data-id="element-134">
        <FadeIn className="text-center mb-16" data-id="element-135">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-136">Preguntas Frecuentes</h2>
          <p className="text-xl text-text-brown/70" data-id="element-137">
            Resolvemos todas tus dudas antes de empezar.
          </p>
        </FadeIn>

        <div className="space-y-4" data-id="element-138">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} delay={i * 0.1} data-id="element-139" />)}
        </div>
      </div>
    </section>;
};
const FAQItem = ({
  question,
  answer,
  delay
}: {
  question: string;
  answer: string;
  delay: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={delay} direction="up" data-id="element-140">
      <div className="bg-white rounded-2xl border border-beige overflow-hidden" data-id="element-141">
        <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-142">
          <span className="font-bold text-lg pr-4" data-id="element-143">{question}</span>
          <ChevronDown className={`w-5 h-5 text-accent-rose-deep transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-144" />
        </button>
        <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-145">
          <p className="text-text-brown/80 leading-relaxed" data-id="element-146">{answer}</p>
        </div>
      </div>
    </FadeIn>;
};